module.exports = __webpack_public_path__ + "img/italic.327bd7ac.svg";